import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { useRef } from "react";
import { AxiosError } from "axios";
import MaintenancePage from "@quest/shared/maintenance/maintenancePage";

type Props = {
  children: React.ReactNode;
};

export const ReactQueryProviderWrapper = ({ children }: Props) => {
  const queryClient = useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 0,
        },
      },
      queryCache: new QueryCache({
        onError: (error) => {
          if (error instanceof AxiosError) {
            if (error.response?.data?.error === "Service Unavailable") {
              return (
                <div className="flex items-center justify-center h-screen">
                  <MaintenancePage />
                </div>
              );
            }
          }
        },
      }),
    })
  ).current;

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
